import { ProjectBase } from './base-classes/project-base'
import { auth } from './auth.module'

const projectBase = new ProjectBase()

projectBase.state.all.defaultFilter = {
  active: true,
  invoiceable: true,
  projectCode: '',
  projectOwnerUserInitials: auth.state.user.initials,
  projectReviewerUserInitials: '',
  orderByColumn: 'projectCode',
  orderByDescending: false,
  tags: []
}

export const projectsInvoice = {
  namespaced: true,
  state: projectBase.state,
  actions: projectBase.actions(),
  mutations: projectBase.mutations(),
  getters: projectBase.getters()
}



// WEBPACK FOOTER //
// ./src/store/project-invoice.module.js